import { render, staticRenderFns } from "./sharedResourceProductAddDialog.vue?vue&type=template&id=1e78bc14&scoped=true"
import script from "./sharedResourceProductAddDialog.vue?vue&type=script&lang=js"
export * from "./sharedResourceProductAddDialog.vue?vue&type=script&lang=js"
import style0 from "./sharedResourceProductAddDialog.vue?vue&type=style&index=0&id=1e78bc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78bc14",
  null
  
)

export default component.exports